var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('RoundedIcon',_vm._g({attrs:{"icon-name":_vm.icon,"main-color":"transparent","hover-color":_vm.backgroundColor,"text-color":_vm.color,"hover-text-color":_vm.color,"has-hover":true,"background-size":_vm.computedBackgroundSize,"icon-size":_vm.computedIconSize,"alt":_vm.alt}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }